import { render, staticRenderFns } from "./CadastreBuildingIndexEditModal.vue?vue&type=template&id=31de46a4&scoped=true&"
import script from "./CadastreBuildingIndexEditModal.vue?vue&type=script&lang=js&"
export * from "./CadastreBuildingIndexEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31de46a4",
  null
  
)

export default component.exports